<template>
  <div class="row">
    <div class="col">
      <div @click="$emit('back')" class="pointer">
        <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Search results</h1>
      </div>
      <div>
        <p>
          Please select your account so we can connect it with your company here on Mod24 and send payouts.
        </p>
      </div>
      <template v-if="searchResults.length">
        <div class="row" v-for="vendor in searchResults" :key="vendor.networkId">
          <div class="col">
            <div class="add-billing-options mt-3 mx-3">
              <div class="billing-option pointer" @click="selectedVendor = vendor"
                   :class="{'billing-option-selected': selectedVendor.networkId === vendor.networkId}"
              >
                <div class="billing-details d-flex align-items-center">
                  <div class="billing-option-info">
                    <h5>{{ vendor.displayName }}</h5>
                    <p v-if="buildAddress" class="billing-option-description">{{ buildAddress(vendor) }}</p>
                  </div>
                </div>
                <span v-if="selectedVendor.networkId === vendor.networkId" class="mod-icon-billing-option-checked" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="row mt-3 mb-3">
        <div class="col text-right">
          <button type="button"
                  class="btn btn-secondary"
                  @click="$emit('cancel')"
          >
            Cancel
          </button>
          <button class="btn btn-primary ld-ext-right"
                  @click="invite"
                  :class="loadingButton ? 'running' : ''"
                  :disabled="!selectedVendor || buttonDisabled"
          >
            Submit
            <div class="ld ld-ball ld-flip" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';

export default {
  name: 'VendorSearchResults',
  props: {
    searchResults: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    buttonDisabled: false,
    loadingButton: false,
    selectedVendor: '',
  }),
  methods: {
    buildAddress(vendor) {
      if (vendor.addressLine1 || vendor.addressZip || vendor.addressCity || vendor.addressState) {
        let address = '';
        address += vendor.addressLine1 ? `${vendor.addressLine1}, ` : '';
        address += vendor.addressZip ? `${vendor.addressZip}, ` : '';
        address += vendor.addressCity ? `${vendor.addressCity}, ` : '';
        address += vendor.addressState ? `${vendor.addressState}` : '';

        return address;
      }
      return '';
    },
    invite() {
      this.buttonDisabled = true;
      this.loadingButton = true;
      const requestData = {
        action: 'sendInvite',
        addressCity: this.selectedVendor.addressCity ? this.selectedVendor.addressCity : null,
        addressLine1: this.selectedVendor.addressLine1 ? this.selectedVendor.addressLine1 : null,
        addressState: this.selectedVendor.addressState ? this.selectedVendor.addressState : null,
        addressZip: this.selectedVendor.addressZip ? this.selectedVendor.addressZip : null,
        company_id: this.$route.params.id,
        name: this.selectedVendor.displayName,
        networkId: this.selectedVendor.networkId,
      };
      axios
        .post(`bill/create-action`, requestData)
        .then(() => {
          toastr.success('Invitation email sent to selected vendor.');
          this.$emit('cancel');
        })
        .catch(err => this.errors.record(err.response.data.error))
        .finally(() => {
          this.buttonDisabled = false;
          this.loadingButton = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.billing-option-selected {
  border: 1px solid #0f47e2 !important;
}

.billing-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 15px 5px 15px;
  border-radius: 5px;
  border: 1px solid #ffffff;
  cursor: pointer;

  .billing-option-info {
    display: flex;
    flex-direction: column;
    flex: 1;

    .billing-option-description {
      font-size: 0.8rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/companies/mod24settings/VendorSearchResults.vue